import React from "react";

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="spin center-vertically">
        <span>loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
